// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 2560px) {
  .home_article_card_skeleton_container {
    height: 550px !important;
    width: 1200px !important;
    padding: 10px 10px 10px 10px;
  }

  .home_article_card_skeleton_thumbnail {
    height: 545px !important;
  }

  .home_article_card_details_skeleton_wrapper {
    height: 545px !important;
    width: 570px !important;
  }

  .home_article_card_skeleton_title {
    height: 120px !important;
    width: 560px !important;
  }
  .home_article_card_skeleton_subtitle {
    height: 230px !important;
    width: 560px !important;
  }

  .home_article_card_skeleton_author_details {
    height: 50px !important;
    width: 220px !important;
  }
  .home_article_card_author_details {
    width: 100px !important;
  }
 
  .home_article_card_skeleton_continue_read {
    height: 50px !important;
    width: 560px !important;
  }

  .home_article_card_skeleton_thumbnail {
    height: 545px !important;
    width: 500px !important;
  }
  .home_article_card_details_skeleton_wrapper {
    height: 545px !important;
    width: 350px !important;
  }
  .home_article_card_skeleton_title {
    height: 120px !important;
    width: 695px !important;
  }
  .home_article_card_skeleton_subtitle {
    height: 230px !important;
    width: 695px !important;
  }
  .home_article_card_skeleton_author_details {
    height: 50px !important;
    width: 280px !important;
  }
  .home_article_card_skeleton_author_details_wrapper {
    height: 50px !important;
    width: 695px !important;
  }
  .home_article_card_skeleton_continue_read {
    height: 50px !important;
    width: 695px !important;
  }
  .fact_check_middle_card_title_wrapper {
    height: 220px !important;
    gap: 10px;
  }
  .fact_check_middle_card_title_skeleton {
    height: 60px !important;
  }
  .fact_check_middle_card_sub_title_skeleton {
    height: 40px !important;
  }

  .square_skeleton {
    width: 120px !important;
    height: 40px !important;
  }
  .fact_check_middle_card_sub_title_wrapper {
    height: 150px;
    gap: 10px;
  }
  .home_slot_card_container {
    height: 800px;
    width: 600px;
  }
  .home_slot_card_image_skeleton {
    border-radius: 1px 1px 10px 10px;
  }
  .home_slot_card_image_skeleton {
    height: 300px !important;
    width: 600px !important;
  }
  .home_slot_card_title_wrapper {
    height: 130px !important;
    width: 600px !important;
  }
  .home_slot_card_title_skeleton {
    padding: 12px !important;
  }
  .home_slot_card_title_skeleton {
    height: 120px !important;
    width: 600px !important;
  }

  .home_slot_card_content_wrapper {
    height: 170px !important;
    width: 600px !important;
  }

  .home_slot_card_content_skeleton {
    height: 170px !important;
    width: 600px !important;
    padding: 17px;
  }
  .home_slot_card_views_wrapper {
    height: 120px !important;
    width: 600px !important;
    padding: 14px;
  }
  .home_slot_card_views_skeleton {
    height: 52px !important;
    width: 290px !important;
  }
  .home_slot_card_read_more_skeleton {
    height: 50px !important;
    width: 600px !important;
  }
  .home_article_title {
    font-size: 35px;
  }

  .home_article_title_text {
    font-size: 63px;
    font-weight: bold;
  }
  .title_text {
    font-size: 25px;
  }
  .sub_title_text {
    font-size: 21px;
  }
  .reading_icon {
    font-size: 33px;
  }
  .view_icon {
    font-size: 35px;
  }
  .continue_reading_text {
    font-size: 20px;
  }
  .continue_reading_text_ta {
    font-size: 20px;
  }


  .home_trending_title_text {
    font-size: 19px !important;
  }
  .inner_row_content {
    width: 100%;
  }

  .exposing_fake_news_first_column_details {
    height: 202px;
  }
  .home_article_second_column_details {
    height: 190px;
  }
  .exposing_fake_news_second_column_title {
    font-size: 24px;
    font-weight: 700;
  }

  .exposing_fake_news_second_column_sub_title {
    font-size: 18px;
  }
  .exposing_fake_news_second_column_author_name {
    font-size: 18px;
  }
  .exposing_fake_news_second_column_details {
    width: 70px;
    font-size: 18px;
  }

  .exposing_fake_news_first_column_title {
    font-size: 20px;
  }

  .home_article_second_column_writer_name_and_views {
    font-size: 25px;
  }
  .home_page_videos_thumbnail {
    object-fit: cover;
    border-radius: 10px;
    height: 740px;
  }
  .home_page_videos_text_content {
    color: #fff;
    font-size: large;
  }
  .home_page_videos_thumbnail_div {
    width: 100%;
  }
  .home_videos_second_column_contents {
    width: 90%;
    display: grid;
    justify-content: center;
    grid-template-columns: 33% 33% 33%;
  }
  .home_videos_section_mobile_view {
    display: none !important;
  }

  .empower_truth_tag {
    font-size: 70px !important;
  }
  .become_a_member_button {
    font-size: 30px !important;
    height: 80px !important;
  }
  .home_user_contribution_two_profile {
    font-size: 23px !important;
  }
  .home_user_contribution_mobile_view_main_container {
    display: none !important;
  }

  .home_slot_card_views_skeleton {
    height: 52px !important;
    width: 290px !important;
  }
  .home_slot_card_read_more_skeleton {
    height: 35px !important;
    width: 600px !important;
    padding: 14px;
  }
  .signatory_logo {
    width: 300px;
    cursor: pointer !important;
  }
  .home_slot_and_logo_wrapper {
    width: 95%;
    height: 603px;
  }
  .slots_card_wrapper {
    width: 100%;
  }
  .exposing_fake_news_third_column_title {
    font-size: 22px;
  }
  .exposing_fake_news_third_column_name {
    font-size: 19px;
  }

  .home_article_row_wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
  }
  .home_fact_check_mobile_view_wrapper {
    display: none !important;
  }
  .exposing_fake_news_button {
    height: 70px;
    font-size: 22px;
  }
  .user_contribute_stories_main_container {
    grid-template-columns: 23% 40% 32% !important;
  }
  .user_contributed_story_container_image {
    height: 420px !important;
  }
  .user_contributed_story_container {
    height: 1000px !important;
  }
  .home_user_contribute_title {
    font-size: 34px !important;
  }
  .home_user_contribute_subtitle {
    font-size: 26px !important;
    line-height: 36px;
  }
  .contribute_user_name,
  .time-tag,
  .user_contribute_publish_time,
  .view-count-tag {
    font-size: 20px !important;
  }

  .reading_time_icon,
  .view-count-icon {
    width: 30px;
  }

  .home_user_contribution_two_image_box {
    width: 350px !important;
    height: 200px !important;
  }
  .home_user_contribution_two_title {
    font-size: 25px !important;
    line-height: 40px;
  }
  .top_contributor_profile {
    width: 120px !important;
  }
  .user_contributed_module_title {
    font-size: 50px !important;
  }

  .top_contribute_title_ta {
    font-size: 30px;
  }
  .top_contribute_title {
    font-size: 35px !important;
  }
  .user_contributed_module_title {
    height: 190px !important;
  }
  .become_member_content {
    font-size: 40px !important;
  }
  .become_member_content_ta {
    font-size: 40px !important;
  }
  .user_contributed_story_column_box {
    padding: 60px !important;
  }
  .home_videos_subscribe_button {
    background-color: #ef1d26;
    color: #fff;
    border-radius: 10px;
    width: 50%;
    height: 40px;
    align-items: center;
    justify-content: space-around;
    display: flex;
    margin-bottom: 20px;
  }
  .home_awards_card_image_overlay_text {
    font-family: "Lato";
    font-size: 23px;
  }
  .home_article_row_wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .donation_hash_text {
    font-size: 80px !important;
  }
  .donation_fight_against_text {
    font-size: 45px !important;
  }
  .home_donatio_content {
    font-size: 25px;
  }

  .hide_content_in_desktop {
    display: none;
  }

  .slot_main_container {
    width: 24%;
    height: 100%;
  }
  .slot_image_box {
    height: 380px !important;
  }
  .slot_card_title {
    font-size: 25px !important;
  }
  .slot_card_title_en {
    font-size: 27px !important;
  }
  .slot_card_sub_title_en {
    font-size: 22px !important;
  }
  .slot_card_sub_title {
    font-size: 23px !important;
    height: 240px !important;
  }

  .home_logo_and_container {
    margin-top: 30px !important;
    height: calc((850 / 2560) * 100vw) !important;
  }
  .home_slot_description {
    font-size: 33px !important;
  }
  .home_slot_youturn_present_title {
    font-size: 30px !important;
  }
  .home_slot_title {
    font-size: 75px !important;
  }
  .home_user_contribution_image {
    width: 300px !important;
  }
  .home_user_contribution_second_card_container {
    justify-content: space-between !important;
  }

  .donate_amt_content_text {
    font-size: 25px;
  }

  .donate_inr_text {
    font-size: 19px;
  }
  .badge_default {
    height: 45px;
    width: 85px;
    font-size: 19px;
  }
  .home_donate_button {
    width: 200px;
    font-size: 19px;
    height: 70px;
  }
  .home_donate_button_disabled {
    width: 200px;
    font-size: 19px;
    height: 70px;
  }
  .badge_selected {
    height: 45px;
    width: 85px;
    font-size: 19px;
  }

  .home_donation_third_column_container {
    justify-content: flex-end;
  }

  .home_videos_second_column_overlay_play_button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px; /* Adjust the size as needed */
    height: 40px; /* Adjust the size as needed */
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .home_slots_background_container {
    height: 500px !important;
  }
  .home_slots_background_image_container {
    margin-top: 500px !important;
    padding-left: 110px;
  }
  .top_contributor_main_container {
    height: 250px !important;
  }
  .fact_check_party_wise_module_title {
    font-size: 50px !important;
  }

  .home_slot_card_author_detail {
    height: 40px;
    width: 100%;
  }
  .slot_card_title_container {
    font-size: 27px;
    line-height: 33px;
  }
  .slot_card_subtitle_container {
    height: 330px;

    font-size: 21px;
    line-height: 33px;
  }
  .slot_card_subtitle_container_ta {
    height: 368px;
    font-size: 22px;
    line-height: 33px;
  }
  .home_slot_card_author_name {
    font-size: 22px;
  }
  .time_tag_text {
    font-size: 20px;
  }
  .slots_card_wrapper {
    padding-left: 110px;
    padding-right: 60px;
  }
  .user_contributed_story_container_footer {
    height: 25px;
  }
  .home_user_contribution_card_container {
    height: 200px;
  }
  .home_trending_author_text {
    font-size: 19px;
  }
  .header_drawer_theme {
    display: none !important;
  }
  .fact_trending_image {
    height: 330px;
  }
  .exposing_fake_news_first_column_skeleton {
    width: 950px !important;
    height: 900px !important;
  }
  .exposing_fake_news_first_column_writer_name_and_views {
    font-size: 20px;
  }
  .exposing_fake_news_third_column_skeleton {
    height: 400px !important;
    width: 550px !important;
  }
  .donation_second_row_container > h1 {
    font-size: 7.5rem;
  }
  .home_page_videos_text_content_ta {
    font-size: 22px !important;
  }
  .fact_check_browse_categories_title {
    font-size: 50px !important;
  }
  .donation_third_row_container_ta > h6 {
    justify-content: center;
  }
  .slot_card_img {
    object-fit: cover;
  }
  .user_contributed_module_title_ta {
    height: 230px;
  }

  .home_videos_thumbnail_overlay_content {
    height: 180px;
  }
  .exposing_fake_news_first_column_title_ta {
    font-size: 22px !important;
  }
  .exposing_fake_news_first_column_view_icon {
    font-size: 22px;
  }

  .home_videos_thumbnail_overlay_text {
    font-size: 22px;
  }
  .home_videos_thumbnail_overlay_viewed_text {
    font-size: 20px;
  }
  .home_videos_viewed_count_and_published {
    font-size: 20px;
  }
  .see_all_btn {
    font-size: 22px !important;
    height: 45px;
  }
  .home_videos_thumbnail_overlay_play_icon {
    width: 90px;
  }
  .subscribe_btn {
    font-size: 22px;
  }
  .home_awards_section_title {
    font-size: 35px;
  }
  .home_article_button_in_mobile {
    display: none;
  }
  .home_amount_container_ta {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: center;
  }
  .home_amount_container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
  .app-download-icon{
    width: 4%;
    height: 8%;
    position: fixed;
    left: 10px;
    bottom: 75px;
    background-color: #0065cc;
    border-radius: 50%;
    z-index: 99;
    cursor: pointer;
    border: 1px solid #0065cc;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_2560_layout/screen_2560_home.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,gCAAgC;EAClC;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;;EAGA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,kCAAkC;EACpC;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;;;;IAIE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,6CAA6C;EAC/C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yCAAyC;EAC3C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW,EAAE,8BAA8B;IAC3C,YAAY,EAAE,8BAA8B;IAC5C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;;EAGA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;;IAEb,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,yBAAyB;EAC3B;AACF","sourcesContent":["@media only screen and (min-width: 2560px) {\n  .home_article_card_skeleton_container {\n    height: 550px !important;\n    width: 1200px !important;\n    padding: 10px 10px 10px 10px;\n  }\n\n  .home_article_card_skeleton_thumbnail {\n    height: 545px !important;\n  }\n\n  .home_article_card_details_skeleton_wrapper {\n    height: 545px !important;\n    width: 570px !important;\n  }\n\n  .home_article_card_skeleton_title {\n    height: 120px !important;\n    width: 560px !important;\n  }\n  .home_article_card_skeleton_subtitle {\n    height: 230px !important;\n    width: 560px !important;\n  }\n\n  .home_article_card_skeleton_author_details {\n    height: 50px !important;\n    width: 220px !important;\n  }\n  .home_article_card_author_details {\n    width: 100px !important;\n  }\n \n  .home_article_card_skeleton_continue_read {\n    height: 50px !important;\n    width: 560px !important;\n  }\n\n  .home_article_card_skeleton_thumbnail {\n    height: 545px !important;\n    width: 500px !important;\n  }\n  .home_article_card_details_skeleton_wrapper {\n    height: 545px !important;\n    width: 350px !important;\n  }\n  .home_article_card_skeleton_title {\n    height: 120px !important;\n    width: 695px !important;\n  }\n  .home_article_card_skeleton_subtitle {\n    height: 230px !important;\n    width: 695px !important;\n  }\n  .home_article_card_skeleton_author_details {\n    height: 50px !important;\n    width: 280px !important;\n  }\n  .home_article_card_skeleton_author_details_wrapper {\n    height: 50px !important;\n    width: 695px !important;\n  }\n  .home_article_card_skeleton_continue_read {\n    height: 50px !important;\n    width: 695px !important;\n  }\n  .fact_check_middle_card_title_wrapper {\n    height: 220px !important;\n    gap: 10px;\n  }\n  .fact_check_middle_card_title_skeleton {\n    height: 60px !important;\n  }\n  .fact_check_middle_card_sub_title_skeleton {\n    height: 40px !important;\n  }\n\n  .square_skeleton {\n    width: 120px !important;\n    height: 40px !important;\n  }\n  .fact_check_middle_card_sub_title_wrapper {\n    height: 150px;\n    gap: 10px;\n  }\n  .home_slot_card_container {\n    height: 800px;\n    width: 600px;\n  }\n  .home_slot_card_image_skeleton {\n    border-radius: 1px 1px 10px 10px;\n  }\n  .home_slot_card_image_skeleton {\n    height: 300px !important;\n    width: 600px !important;\n  }\n  .home_slot_card_title_wrapper {\n    height: 130px !important;\n    width: 600px !important;\n  }\n  .home_slot_card_title_skeleton {\n    padding: 12px !important;\n  }\n  .home_slot_card_title_skeleton {\n    height: 120px !important;\n    width: 600px !important;\n  }\n\n  .home_slot_card_content_wrapper {\n    height: 170px !important;\n    width: 600px !important;\n  }\n\n  .home_slot_card_content_skeleton {\n    height: 170px !important;\n    width: 600px !important;\n    padding: 17px;\n  }\n  .home_slot_card_views_wrapper {\n    height: 120px !important;\n    width: 600px !important;\n    padding: 14px;\n  }\n  .home_slot_card_views_skeleton {\n    height: 52px !important;\n    width: 290px !important;\n  }\n  .home_slot_card_read_more_skeleton {\n    height: 50px !important;\n    width: 600px !important;\n  }\n  .home_article_title {\n    font-size: 35px;\n  }\n\n  .home_article_title_text {\n    font-size: 63px;\n    font-weight: bold;\n  }\n  .title_text {\n    font-size: 25px;\n  }\n  .sub_title_text {\n    font-size: 21px;\n  }\n  .reading_icon {\n    font-size: 33px;\n  }\n  .view_icon {\n    font-size: 35px;\n  }\n  .continue_reading_text {\n    font-size: 20px;\n  }\n  .continue_reading_text_ta {\n    font-size: 20px;\n  }\n\n\n  .home_trending_title_text {\n    font-size: 19px !important;\n  }\n  .inner_row_content {\n    width: 100%;\n  }\n\n  .exposing_fake_news_first_column_details {\n    height: 202px;\n  }\n  .home_article_second_column_details {\n    height: 190px;\n  }\n  .exposing_fake_news_second_column_title {\n    font-size: 24px;\n    font-weight: 700;\n  }\n\n  .exposing_fake_news_second_column_sub_title {\n    font-size: 18px;\n  }\n  .exposing_fake_news_second_column_author_name {\n    font-size: 18px;\n  }\n  .exposing_fake_news_second_column_details {\n    width: 70px;\n    font-size: 18px;\n  }\n\n  .exposing_fake_news_first_column_title {\n    font-size: 20px;\n  }\n\n  .home_article_second_column_writer_name_and_views {\n    font-size: 25px;\n  }\n  .home_page_videos_thumbnail {\n    object-fit: cover;\n    border-radius: 10px;\n    height: 740px;\n  }\n  .home_page_videos_text_content {\n    color: #fff;\n    font-size: large;\n  }\n  .home_page_videos_thumbnail_div {\n    width: 100%;\n  }\n  .home_videos_second_column_contents {\n    width: 90%;\n    display: grid;\n    justify-content: center;\n    grid-template-columns: 33% 33% 33%;\n  }\n  .home_videos_section_mobile_view {\n    display: none !important;\n  }\n\n  .empower_truth_tag {\n    font-size: 70px !important;\n  }\n  .become_a_member_button {\n    font-size: 30px !important;\n    height: 80px !important;\n  }\n  .home_user_contribution_two_profile {\n    font-size: 23px !important;\n  }\n  .home_user_contribution_mobile_view_main_container {\n    display: none !important;\n  }\n\n  .home_slot_card_views_skeleton {\n    height: 52px !important;\n    width: 290px !important;\n  }\n  .home_slot_card_read_more_skeleton {\n    height: 35px !important;\n    width: 600px !important;\n    padding: 14px;\n  }\n  .signatory_logo {\n    width: 300px;\n    cursor: pointer !important;\n  }\n  .home_slot_and_logo_wrapper {\n    width: 95%;\n    height: 603px;\n  }\n  .slots_card_wrapper {\n    width: 100%;\n  }\n  .exposing_fake_news_third_column_title {\n    font-size: 22px;\n  }\n  .exposing_fake_news_third_column_name {\n    font-size: 19px;\n  }\n\n  .home_article_row_wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 30px;\n  }\n  .home_fact_check_mobile_view_wrapper {\n    display: none !important;\n  }\n  .exposing_fake_news_button {\n    height: 70px;\n    font-size: 22px;\n  }\n  .user_contribute_stories_main_container {\n    grid-template-columns: 23% 40% 32% !important;\n  }\n  .user_contributed_story_container_image {\n    height: 420px !important;\n  }\n  .user_contributed_story_container {\n    height: 1000px !important;\n  }\n  .home_user_contribute_title {\n    font-size: 34px !important;\n  }\n  .home_user_contribute_subtitle {\n    font-size: 26px !important;\n    line-height: 36px;\n  }\n  .contribute_user_name,\n  .time-tag,\n  .user_contribute_publish_time,\n  .view-count-tag {\n    font-size: 20px !important;\n  }\n\n  .reading_time_icon,\n  .view-count-icon {\n    width: 30px;\n  }\n\n  .home_user_contribution_two_image_box {\n    width: 350px !important;\n    height: 200px !important;\n  }\n  .home_user_contribution_two_title {\n    font-size: 25px !important;\n    line-height: 40px;\n  }\n  .top_contributor_profile {\n    width: 120px !important;\n  }\n  .user_contributed_module_title {\n    font-size: 50px !important;\n  }\n\n  .top_contribute_title_ta {\n    font-size: 30px;\n  }\n  .top_contribute_title {\n    font-size: 35px !important;\n  }\n  .user_contributed_module_title {\n    height: 190px !important;\n  }\n  .become_member_content {\n    font-size: 40px !important;\n  }\n  .become_member_content_ta {\n    font-size: 40px !important;\n  }\n  .user_contributed_story_column_box {\n    padding: 60px !important;\n  }\n  .home_videos_subscribe_button {\n    background-color: #ef1d26;\n    color: #fff;\n    border-radius: 10px;\n    width: 50%;\n    height: 40px;\n    align-items: center;\n    justify-content: space-around;\n    display: flex;\n    margin-bottom: 20px;\n  }\n  .home_awards_card_image_overlay_text {\n    font-family: \"Lato\";\n    font-size: 23px;\n  }\n  .home_article_row_wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .donation_hash_text {\n    font-size: 80px !important;\n  }\n  .donation_fight_against_text {\n    font-size: 45px !important;\n  }\n  .home_donatio_content {\n    font-size: 25px;\n  }\n\n  .hide_content_in_desktop {\n    display: none;\n  }\n\n  .slot_main_container {\n    width: 24%;\n    height: 100%;\n  }\n  .slot_image_box {\n    height: 380px !important;\n  }\n  .slot_card_title {\n    font-size: 25px !important;\n  }\n  .slot_card_title_en {\n    font-size: 27px !important;\n  }\n  .slot_card_sub_title_en {\n    font-size: 22px !important;\n  }\n  .slot_card_sub_title {\n    font-size: 23px !important;\n    height: 240px !important;\n  }\n\n  .home_logo_and_container {\n    margin-top: 30px !important;\n    height: calc((850 / 2560) * 100vw) !important;\n  }\n  .home_slot_description {\n    font-size: 33px !important;\n  }\n  .home_slot_youturn_present_title {\n    font-size: 30px !important;\n  }\n  .home_slot_title {\n    font-size: 75px !important;\n  }\n  .home_user_contribution_image {\n    width: 300px !important;\n  }\n  .home_user_contribution_second_card_container {\n    justify-content: space-between !important;\n  }\n\n  .donate_amt_content_text {\n    font-size: 25px;\n  }\n\n  .donate_inr_text {\n    font-size: 19px;\n  }\n  .badge_default {\n    height: 45px;\n    width: 85px;\n    font-size: 19px;\n  }\n  .home_donate_button {\n    width: 200px;\n    font-size: 19px;\n    height: 70px;\n  }\n  .home_donate_button_disabled {\n    width: 200px;\n    font-size: 19px;\n    height: 70px;\n  }\n  .badge_selected {\n    height: 45px;\n    width: 85px;\n    font-size: 19px;\n  }\n\n  .home_donation_third_column_container {\n    justify-content: flex-end;\n  }\n\n  .home_videos_second_column_overlay_play_button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 40px; /* Adjust the size as needed */\n    height: 40px; /* Adjust the size as needed */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n\n  .home_slots_background_container {\n    height: 500px !important;\n  }\n  .home_slots_background_image_container {\n    margin-top: 500px !important;\n    padding-left: 110px;\n  }\n  .top_contributor_main_container {\n    height: 250px !important;\n  }\n  .fact_check_party_wise_module_title {\n    font-size: 50px !important;\n  }\n\n  .home_slot_card_author_detail {\n    height: 40px;\n    width: 100%;\n  }\n  .slot_card_title_container {\n    font-size: 27px;\n    line-height: 33px;\n  }\n  .slot_card_subtitle_container {\n    height: 330px;\n\n    font-size: 21px;\n    line-height: 33px;\n  }\n  .slot_card_subtitle_container_ta {\n    height: 368px;\n    font-size: 22px;\n    line-height: 33px;\n  }\n  .home_slot_card_author_name {\n    font-size: 22px;\n  }\n  .time_tag_text {\n    font-size: 20px;\n  }\n  .slots_card_wrapper {\n    padding-left: 110px;\n    padding-right: 60px;\n  }\n  .user_contributed_story_container_footer {\n    height: 25px;\n  }\n  .home_user_contribution_card_container {\n    height: 200px;\n  }\n  .home_trending_author_text {\n    font-size: 19px;\n  }\n  .header_drawer_theme {\n    display: none !important;\n  }\n  .fact_trending_image {\n    height: 330px;\n  }\n  .exposing_fake_news_first_column_skeleton {\n    width: 950px !important;\n    height: 900px !important;\n  }\n  .exposing_fake_news_first_column_writer_name_and_views {\n    font-size: 20px;\n  }\n  .exposing_fake_news_third_column_skeleton {\n    height: 400px !important;\n    width: 550px !important;\n  }\n  .donation_second_row_container > h1 {\n    font-size: 7.5rem;\n  }\n  .home_page_videos_text_content_ta {\n    font-size: 22px !important;\n  }\n  .fact_check_browse_categories_title {\n    font-size: 50px !important;\n  }\n  .donation_third_row_container_ta > h6 {\n    justify-content: center;\n  }\n  .slot_card_img {\n    object-fit: cover;\n  }\n  .user_contributed_module_title_ta {\n    height: 230px;\n  }\n\n  .home_videos_thumbnail_overlay_content {\n    height: 180px;\n  }\n  .exposing_fake_news_first_column_title_ta {\n    font-size: 22px !important;\n  }\n  .exposing_fake_news_first_column_view_icon {\n    font-size: 22px;\n  }\n\n  .home_videos_thumbnail_overlay_text {\n    font-size: 22px;\n  }\n  .home_videos_thumbnail_overlay_viewed_text {\n    font-size: 20px;\n  }\n  .home_videos_viewed_count_and_published {\n    font-size: 20px;\n  }\n  .see_all_btn {\n    font-size: 22px !important;\n    height: 45px;\n  }\n  .home_videos_thumbnail_overlay_play_icon {\n    width: 90px;\n  }\n  .subscribe_btn {\n    font-size: 22px;\n  }\n  .home_awards_section_title {\n    font-size: 35px;\n  }\n  .home_article_button_in_mobile {\n    display: none;\n  }\n  .home_amount_container_ta {\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    align-items: center;\n  }\n  .home_amount_container {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n  }\n  .app-download-icon{\n    width: 4%;\n    height: 8%;\n    position: fixed;\n    left: 10px;\n    bottom: 75px;\n    background-color: #0065cc;\n    border-radius: 50%;\n    z-index: 99;\n    cursor: pointer;\n    border: 1px solid #0065cc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
